import BaseController from '..';
import {
    PlatformSuperAdminEmailList,
    PlatformSuperAdminMeResponse,
    PlatformSuperAdminDatabaseRecord
} from '../../../models/entities/platform/platformSuperAdmin';
import IPlatformSuperAdmin from './IPlatformSuperAdmin';

export default class PlatformSuperAdminController extends BaseController implements IPlatformSuperAdmin {
    constructor(baseUrl: string) {
        super(baseUrl);
    }

    async fetchMe(): Promise<PlatformSuperAdminMeResponse> {
        return this.client.get('/super-admin/me');
    }

    async listPlatformAdmins(): Promise<PlatformSuperAdminEmailList> {
        return this.client.get('/super-admin/platform-admins');
    }

    async addPlatformAdmin(email: string): Promise<PlatformSuperAdminDatabaseRecord> {
        return this.client.post('/super-admin/platform-admins', JSON.stringify({ email }));
    }

    async revokePlatformAdmin(email: string): Promise<{ ok: boolean }> {
        return this.client.delete(`/super-admin/platform-admins/${encodeURIComponent(email)}`);
    }
}
